import { render, staticRenderFns } from "./DrinkVolume.vue?vue&type=template&id=5c18d9c9&scoped=true&"
import script from "./DrinkVolume.vue?vue&type=script&lang=js&"
export * from "./DrinkVolume.vue?vue&type=script&lang=js&"
import style0 from "./DrinkVolume.vue?vue&type=style&index=0&id=5c18d9c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c18d9c9",
  null
  
)

export default component.exports